import cx from 'clsx';

import { TProps } from './types/TProps';

export const EnvironmentRibbon = ({ label, className }: TProps) => (
  <span aria-hidden="true" className={cx('env-ribbon', className)}>
    {label}
  </span>
);
